import { handleActions } from 'redux-actions';
import { defaultPromotionalBannersWidgetState } from './defaults';
import { PromotionalBannersWidgetData } from './types';
import { initPromosPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  savePromotionalBanners,
  savePromotionalBannersFailure,
  savePromotionalBannersSuccess,
  setPromotionalBannersWidgetDeviationPageBanner,
  setPromotionalBannersWidgetProfileCoverBanner,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergePromotionalBannersWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultPromotionalBannersWidgetState
  );

export default handleActions<PromotionalBannersWidgetData, any>(
  {
    [initPromosPage.toString()]: (
      state,
      action: ReturnType<typeof initPromosPage>
    ) => {
      const data: PromotionalBannersWidgetData['initialData'] = {
        deviationPageBanner: action.payload.data.banners.deviationPageBanner,
        profileCoverBanner: action.payload.data.banners.profileCoverBanner,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setPromotionalBannersWidgetDeviationPageBanner.toString()]: (
      state,
      action: ReturnType<typeof setPromotionalBannersWidgetDeviationPageBanner>
    ) =>
      mergePromotionalBannersWidgetDataChange(state, {
        deviationPageBanner: action.payload.deviationPageBanner,
      }),
    [setPromotionalBannersWidgetProfileCoverBanner.toString()]: (
      state,
      action: ReturnType<typeof setPromotionalBannersWidgetProfileCoverBanner>
    ) =>
      mergePromotionalBannersWidgetDataChange(state, {
        profileCoverBanner: action.payload.profileCoverBanner,
      }),
    ...saveRequestMetaReducer({
      initialAction: savePromotionalBanners,
      successAction: savePromotionalBannersSuccess,
      failureAction: savePromotionalBannersFailure,
    }),
  },
  defaultPromotionalBannersWidgetState
);
